var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-8"},[_c('div',[_c('ProjectAddAction',{attrs:{"product-id":_vm.productId},on:{"project-added":_vm.onProjectAdded}})],1),_c('div',[_c('ProjectList',{ref:"projectList",attrs:{"product-id":_vm.productId},on:{"change":function($event){return _vm.$emit('refresh')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }